// extracted by mini-css-extract-plugin
export default {"linkCopied":"linkCopied_linkCopied__1KWym"};